import { Col, Row } from "antd";
import InputComponent from "../../../components/InputComponent";
import SelectComponent from "../../../components/SelectComponent";
import { useMobileAppVersionContext } from "../../../context/MobileAppVersionContext/MobileAppVersionContext";
import { APP_OPTIONS, PLATFORM_OPTIONS } from "./constants";

const GeneralInfo = () => {
	const { versionData, setVersionData } = useMobileAppVersionContext();

	const handleVersionChange = (value: string) => {
		const sanitizedVersion = value.replace(/[^0-9.]/g, "");
		setVersionData({ ...versionData, version: sanitizedVersion });
	};

	return (
		<>
			<Row gutter={20}>
				<Col span={12}>
					<InputComponent
						title="Sürüm No"
						placeholder="Örn: 1.0.0"
						isRequired
						value={versionData?.version}
						onChange={(e) => handleVersionChange(e.target.value)}
					/>
				</Col>
			</Row>
			<Row gutter={20}>
				<Col span={10}>
					<SelectComponent
						title="Uygulama"
						placeholder="Uygulama seçiniz"
						options={APP_OPTIONS}
						value={versionData?.appId?.toString() || APP_OPTIONS[0].label}
						onChange={(value) => setVersionData({ ...versionData, appId: Number(value) })}
						isRequired
					/>
				</Col>
				<Col span={10}>
					<SelectComponent
						title="Platform"
						placeholder="Platform seçiniz"
						options={PLATFORM_OPTIONS}
						value={versionData?.platform || PLATFORM_OPTIONS[0].label}
						onChange={(value) => setVersionData({ ...versionData, platform: value })}
						isRequired
					/>
				</Col>
			</Row>
		</>
	);
};

export default GeneralInfo;
